import * as yup from 'yup'

export const emailFieldValidation = yup
    .string()
    .trim()
    .email('Invalid email format')
    .required('This field is required')
    .max(64, 'Email must be at most 64 characters long')
    .test('no-leading-dot', 'Email cannot start with a dot', (value) => {
        if (!value) return true
        return !/^\./.test(value)
    })
    .test('no-trailing-dot', 'Email cannot end with a dot', (value) => {
        if (!value) return true
        return !/\.$/.test(value)
    })
    .test('no-consecutive-dots', 'Email cannot contain consecutive dots', (value) => {
        if (!value) return true
        return !/\.\./.test(value)
    })
    .test('valid-domain', 'Email must have a valid domain (e.g., example.com)', (value) => {
        if (!value) return true
        const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        const domain = value.split('@')[1]
        return domain ? domainRegex.test(domain) : false
    })
    .test('no-invalid-characters', 'Email contains invalid characters', (value) => {
        if (!value) return true
        return /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
    })
    .test('no-multiple-domain-extensions', 'Email cannot have multiple domain extensions.', (value) => {
        if (!value) return true
        const domain = value.split('@')[1]
        return !(domain && domain.split('.').length > 3)
    })

export const signInEmailValidationSchema = yup.object({
    email: emailFieldValidation,
})

export const newsletterValidationSchema = yup.object({
    email: emailFieldValidation,
})

export const signInValidationSchema = yup.object({
    email: emailFieldValidation,
    password: yup.string().required('Password is required'),
    rememberMe: yup.boolean().optional(),
})

export const signUpValidationSchema = yup.object({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    email: emailFieldValidation,
    password: yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
    agreeToTerms: yup.boolean().oneOf([true], 'You must agree to the terms').required(),
})

export const forgotPasswordValidationSchema = yup.object({
    email: emailFieldValidation,
})

export const resetPasswordValidationSchema = yup.object({
    newPassword: yup.string().min(8, 'Password must be at least 8 characters').required('New password is required'),
    confirmPassword: yup.string()
        .oneOf([yup.ref('newPassword')], 'Passwords do not match')
        .required('Please confirm your password'),
})

export const contactValidationSchema = yup.object({
    name: yup.string().required('Name is required'),
    email: emailFieldValidation,
    message: yup.string().min(10, 'Message must be at least 10 characters').required('Message is required'),
})

export const profileInfoValidationSchema = yup.object({
    fullName: yup.string().required('Full name is required'),
    email: emailFieldValidation,
    phone: yup.string().required('Phone number is required'),
    dateOfBirth: yup.string().required('Date of birth is required'),
})

export const changePasswordValidationSchema = yup.object({
    currentPassword: yup.string().required('Current password is required'),
    newPassword: yup.string()
        .min(8, 'Password must be at least 8 characters')
        .notOneOf([yup.ref('currentPassword')], 'New password must be different from current password')
        .required('New password is required'),
    confirmPassword: yup.string()
        .oneOf([yup.ref('newPassword')], 'Passwords do not match')
        .required('Please confirm your password'),
})

export const addNewAddressValidationSchema = yup.object({
    fullName: yup.string().required('Full Name is required'),
    mobileNumber: yup.string().required('Mobile Number is required'),
    country: yup.string().required('Country is required'),
    pincode: yup.string().required('Pincode is required'),
    city: yup.string().optional(),
    state: yup.string().trim().required('State / Region is required'),
    houseNo: yup.string().required('House No is required'),
    street: yup.string().required('Street is required'),
    landmark: yup.string().optional(),
    addressType: yup.string().required('Address Type is required'),
    isDefault: yup.boolean(),
})
